<template>
  <main class="page-main">
    <section class="page-hero">
      <div class="container page-hero__inner">
        <h1>Services at New Shivam Medicos</h1>
        <p>
          An overview of what we offer at our Basistha, Guwahati store. If you are unsure whether we can
          help with a specific request, call <a href="tel:+918876499294">+91 8876499294</a> before visiting.
        </p>
      </div>
    </section>
    <article class="page-article">
      <h2>Prescription and medicines</h2>
      <p>
        We dispense prescriptions presented in person in accordance with applicable regulations. We stock a
        broad range of allopathic medicines and can often arrange alternatives when a brand is out of stock
        (subject to your prescriber’s approval where required).
      </p>

      <h2>Over-the-counter and wellness</h2>
      <p>
        We carry common OTC products, vitamins, first-aid supplies, and personal care items suitable for a
        family medical shop. Staff can help you choose appropriate non-prescription options and direct you to
        a clinician when symptoms need medical attention.
      </p>

      <h2>In-store health support</h2>
      <p>Depending on staff availability, we may offer or arrange:</p>
      <ul>
        <li>Blood pressure measurement</li>
        <li>Basic diabetes-related guidance and product support (not a substitute for your doctor)</li>
        <li>Medication review conversations for dosing schedules and interactions (general information only)</li>
        <li>Referral information for vaccinations or blood collection where we partner with qualified providers</li>
      </ul>

      <h2>What we do not do</h2>
      <p>
        We do not diagnose diseases or prescribe medicines online. We do not guarantee same-day delivery for
        every item. Controlled and special-category drugs are handled strictly as per legal requirements.
      </p>
    </article>
  </main>
</template>

<script>
export default {
  name: "ServicesPage",
};
</script>
